export class MrpCosmosService {
    init() {
        document.addEventListener("DOMContentLoaded", () => {
            this.scrollInventoryButtonIntoView();
            this.addFeatureImageClass();
            this.hideOrShowVehicleCount();
        });
    }
    addFeatureImageClass() {
        const featureImagesElement = document.querySelector(".mrp-feature__images");
        if (featureImagesElement == null) {
            const mrpFeature = document.querySelector(".mrp-feature");
            if (mrpFeature != null) {
                mrpFeature.classList.add("mrp-feature__no-images");
            }
        }
    }
    hideOrShowVehicleCount() {
        const mrpDataElement = document.getElementById("mrpData");
        if (mrpDataElement != null) {
            const mrpInfo = JSON.parse(mrpDataElement.textContent);
            const vehicleCount = Number.parseInt(mrpInfo.VehicleCount);
            for (const element of Array.from(document.querySelectorAll("[data-hide-if-no-count]"))) {
                element.style.display =
                    Number.isNaN(vehicleCount) || vehicleCount <= 0 ? "none" : element.style.display;
            }
        }
    }
    scrollInventoryButtonIntoView() {
        const srpBlockElement = document.querySelector("#cBlock3");
        const buttons = document.querySelectorAll("[data-mrp-element='search-inventory-button']");
        buttons.forEach((button) => {
            button.addEventListener("click", () => {
                srpBlockElement?.scrollIntoView({ behavior: "smooth" });
            });
        });
    }
}
